import axiosInstance from "./axiosInstance";
import { API_ROUTES } from "./constants";

export const createReview = async (reviewData) => {
    try {
        const response = await axiosInstance.post(API_ROUTES.REVIEW.CREATE, reviewData);
        return response.data;
    } catch (error) {
        console.error('Error creating customer:', error);
        throw error;
    }
};

export const updateReview = async (reviewId, updateData) => {
    try {
        const response = await axiosInstance.patch(`${API_ROUTES.REVIEW.UPDATE}/${reviewId}`, updateData);
        return response.data;
    } catch (error) {
        console.error('Error updating review:', error);
        throw error;
    }
};

export const getReview = async (reviewId) => {
    try {
        const response = await axiosInstance.get(`${API_ROUTES.REVIEW.GET_SINGLE_REVIEW}/${reviewId}`);
        return response.data;
    } catch (error) {
        console.error('Error updating review:', error);
        throw error;
    }
};

export const getAllReview = async () => {
    try {
        const response = await axiosInstance.get(`${API_ROUTES.REVIEW.GET}`);
        return response.data;
    } catch (error) {
        console.error('Error updating review:', error);
        throw error;
    }
};

export const getTopRatedReview = async () => {
    try {
        const response = await axiosInstance.get(`${API_ROUTES.REVIEW.TOP_RATED}`);
        return response.data;
    } catch (error) {
        console.error('Error updating review:', error);
        throw error;
    }
};

export const deleteReview = async (reviewId) => {
    try {
        const response = await axiosInstance.delete(API_ROUTES.REVIEW.DELETE, {
            data: {
                ids: reviewId
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting review:', error);
        throw error;
    }
}